import React from "react";

const SelectTemplate = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
              d="M30.268 9.619 22.694 2H4.513C3.678 2 3 2.677 3 3.511v27.454a1.52 1.52 0 0 0 1.505 1.51H17.15a9.178 9.178 0 0 1-.517-3.047c0-5.05 4.07-9.143 9.09-9.143 1.655 0 3.207.446 4.544 1.224V9.619Zm-9.9 18.994L25.724 34l7.498-7.542-2.142-2.155-5.356 5.387-3.214-3.232-2.142 2.155Z"
              fill={fill}
        />
    </svg>
);

export default SelectTemplate;